import { DemographicFormValues } from "@/components/pages/user-info/demographics-form-controlled";
import { LanguageLearningObjectivesFormValues } from "@/components/pages/user-info/language-objectives-form-controlled";
import { UserProfileFormValues } from "@/components/pages/user-profile";

const coreUrl = import.meta.env.VITE_REACT_APP_POCKETBASE_URL;

export const UpdateUserDemographics = async (
  userDemographics: DemographicFormValues,
  id: string | undefined,
  token: string,
): Promise<string> => {
  if (!id) {
    return "User ID is undefined";
  }

  const payload = {
    firstName: userDemographics.firstName,
    lastName: userDemographics.lastName,
    gender: userDemographics.gender,
    ageRange: userDemographics.ageRange,
    country: userDemographics.country,
    nativeLanguage: userDemographics.nativeLanguage,
  };
  const response = await fetch(`${coreUrl}/api/user/${id}/demographics`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return response.ok ? "success" : response.statusText;
};

export const CreateUserLanguageLearningObjectives = async (
  userLanguageLearningObjectives: LanguageLearningObjectivesFormValues,
  id: string | undefined,
  token: string,
): Promise<string> => {
  if (!id) {
    return "User ID is undefined";
  }

  const payload = userLanguageLearningObjectives.learnLanguages;
  const response = await fetch(
    `${coreUrl}/api/user/${id}/learning-objectives`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    },
  );

  return response.ok ? "success" : response.statusText;
};

export const UpdateUserProfile = async (
  userProfileUpdate: UserProfileFormValues,
  id: string | undefined,
  token: string,
): Promise<string> => {
  if (!id) {
    return "User ID is undefined";
  }

  const payload = userProfileUpdate;
  const response = await fetch(`${coreUrl}/api/user/${id}/profile`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return response.ok ? "success" : response.statusText;
};

export const CompleteOnboardingTour = async (
  userId: string | undefined,
  token: string,
): Promise<string> => {
  if (!userId) {
    return "User ID is undefined";
  }

  const response = await fetch(
    `${coreUrl}/api/user/${userId}/onboarding-tour`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response.ok ? "success" : response.statusText;
};
